export default {
  type: "form-multi-option",
  style: "",
  data: {
    label: "New Multi Option",
    options: [
      {
        label: "Option 1",
      },
      {
        label: "Option 2",
      },
      {
        label: "Option 3",
      },
    ],
  },
  children: [],
};
